module.exports = __webpack_public_path__ + "src/submodules/base/assets/img/fs-right-bg.a90be723.svg";